import firebase from 'firebase/app'
import 'firebase/firestore'

const firebaseConfig = {
    apiKey: "AIzaSyAdXYnN9cc2zU5EbE4_-UFbQia9hlHk2Vg",
    authDomain: "jobs-advice.firebaseapp.com",
    projectId: "jobs-advice",
    storageBucket: "jobs-advice.appspot.com",
    messagingSenderId: "1049432138179",
    appId: "1:1049432138179:web:d025538e7550771e0b9d76"
}

export function initApp() {
    if (firebase.apps.length === 0) {
        firebase.initializeApp(firebaseConfig)
    }
}

export function addToCollection(collection, object) {
    initApp()
    firebase.firestore().collection(collection).add(object)
}

export function getAllFromCollection(collection, push) {
    initApp()
    firebase
        .firestore()
        .collection(collection)
        .get()
        .then((snaps) => {
            snaps.forEach((doc) => push(doc.data()))
        })
}